module.exports = [{"featureType":"administrative","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/MapWrapper/mapstyle.json
// module id = 569
// module chunks = 0